export const appendToFormData = (formData, valuesObject) => {
  for (const property in valuesObject) {
    if (valuesObject[property]) {
      formData.append(property, valuesObject[property]);
    }
  }
};

// Spring-style multipart uchun: JSON qismini application/json Blob qilib qo'shadi.
// Oddiy string yuborilsa backend uni parse qila olmaydi.
export const appendJsonPart = (formData, key, value) => {
  formData.append(
    key,
    new Blob([JSON.stringify(value)], { type: "application/json" })
  );
};
